import { bridge, type InitResult } from '@kherel/app-bridge';

/**
 * Construct the SDK transport while the module is loading, before the iframe
 * load event can prompt the parent host to emit TribeHostReady.
 */
export const initialBridgeConnection: Promise<InitResult> | null =
  window.parent === window
    ? null
    : bridge.send('TribeAppInit', undefined, { timeoutMs: 10_000 });
